import { del, get, jsonParser, post, put } from "./Client";

export const searchTraits = (
  query, 
  all = false, 
  page = 0, 
  sort = "order", 
  order = "ASC", 
  drinkId = null, 
  categoryId = null, 
  attributeId = null,
  type = null,
  parentId = null,
) =>
  get(`/traits/alt-list?query=${query}&all=${all ? "true" : "false"}&page=${page}&sort=${sort}&order=${order}${!!drinkId ? "&drinkId=" + drinkId : ""}${!!categoryId ? "&categoryId=" + categoryId : ""}${!!attributeId ? "&attributeId=" + attributeId : ""}${!!type ? "&type=" + type : ""}${!!parentId ? "&parentId=" + parentId : ""}`)
  .then(jsonParser);

export const getTrait = (trait) => 
  get(`/traits/${trait.id}`).then(jsonParser);

export const createTrait = (trait) =>
  post("/traits", { body: trait }).then(jsonParser);

export const updateTrait = (trait) =>
  put(`/traits/${trait.id}`, { body: trait }).then(jsonParser);

export const deleteTrait = (trait) => 
  del(`/traits/${trait.id}`).then(jsonParser);
  
export const listAllTraits = (
  sort = "order", 
  order = "ASC", 
  attributeId = null,
  type = null,
  parentId = null,
) =>
  get(`/traits/all?sort=${sort}&order=${order}${!!attributeId ? "&attributeId=" + attributeId : ""}${!!type ? "&type=" + type : ""}${!!parentId ? "&parentId=" + parentId : ""}`)
  .then(jsonParser);

export const importTraitExcelData = (data) =>
  post("/traits/import/excel", { body: data }).then(jsonParser);